import React, { Component } from 'react';
import { Button, Input, Select, Icon,DatePicker } from 'antd';
import API_URL from '../../../../../common/url';
import ExportUtil from '../../../../../common/ExportUtil';
import SelectBa from '../../../components/SelectBa';
import moment from 'moment';

const { Option } = Select;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class Filter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expand: false,
        };
    }

    search = () => {
        this.props.search();
    }

    export = () => {
        const { searchParams } = this.props;
        const url = API_URL.home.exportInvoicingList;
        searchParams.type="Receive";
        const{year}=searchParams;
        searchParams.year=year?year:moment().format('YYYY'),
        ExportUtil.export({ ...searchParams }, null, url);
    }

    handleKeyPress = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleChange = (value, key) => {
        const { searchParams, onChange } = this.props;
        switch (key) {
            case 'customerBaName': {
                const { lastLeaf, checkedKeys, expandedKeys } = value;
                searchParams.lastLeaf = lastLeaf;
                searchParams.checkedKeys = checkedKeys;
                searchParams.expandedKeys = expandedKeys;
                searchParams.customerBaNameIds = (lastLeaf || []).map(i => i.id).join(',');
                searchParams.customerBaNameNames = (lastLeaf || []).map(i => i.title).join(',');
                onChange(searchParams);
                break;
            }
            default:
                searchParams[key] = value;
                onChange(searchParams);
                break;
        }
    }

    toggleHeight = () => {
        this.setState((prevState) => ({
            expand: !prevState.expand,
        }));
    }

    render () {
        const { searchParams } = this.props;
        const { expand } = this.state;
        var myDate = new Date();       
        var thisYear = myDate.getFullYear(); 
        var Section = thisYear - 2016; 
        var arrYear = [];
        for(var i = 0;i<=Section;i++){
           arrYear.push(thisYear--)
        }
        const timeList = [];
        (arrYear || []).forEach(item => {
            timeList.push({value:item,label:item});
        });
        const timeOption = timeList.map(i => <Option key={i.value}>{i.label}</Option>);
        const { year,lastLeaf, checkedKeys, expandedKeys }=searchParams;
        return (
            <div style={{ marginBottom: 16 }}>
                <div className={`search-bar expand ${expand ? 'expanded' : ''}`}>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">时间</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 150}}
                            value={year}
                            onChange={value => this.handleChange(value, 'year')}
                        >
                            {timeOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <Button type="primary" onClick={this.search}>搜索</Button>
                        <Button type="primary" onClick={this.export}>导出</Button>
                    </div>
                </div>
                {/* <div className="search-bar flex-end">
                </div> */}
                <SelectBa 
                    ref={el => this.selectBaRef = el} 
                    lastLeaf={lastLeaf}
                    checkedKeys={checkedKeys}
                    expandedKeys={expandedKeys}
                    onChange={args => this.handleChange(args, 'customerBaName')}
                />
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestAndReturnedSheet/AnnualPaymentCollectionAnalysis/TablePage/Filter.js